import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const TABS = [
    {
        to: '/',
        matchPrefixes: ['/'],
        labelKey: 'nav.tab_today',
        ariaKey: 'nav.tab_today_aria',
    },
    {
        to: '/library',
        matchPrefixes: ['/library', '/play'],
        labelKey: 'nav.tab_library',
        ariaKey: 'nav.tab_library_aria',
    },
];
export function isTabActive(pathname, tab) {
    if (tab.to === '/')
        return pathname === '/';
    return tab.matchPrefixes.some((p) => pathname === p || pathname.startsWith(p + '/'));
}
export const TAB_DEFS = TABS;
/**
 * TabBar M2 cyanotype — 2 onglets uniquement (DEC-014 utility-first).
 * Indicator trait 2px var(--network) sous l'onglet actif. Pas d'icones,
 * pas de script italic — labels Space Grotesk medium.
 */
export function TabBar() {
    const { t } = useTranslation('common');
    const location = useLocation();
    return (_jsx("nav", { "aria-label": t('nav.tab_bar_aria'), className: "\n        fixed bottom-0 inset-x-0 z-40\n        bg-cyan-surface\n        border-t border-cyan-border-faint\n        pb-[env(safe-area-inset-bottom)]\n      ", children: _jsx("ul", { className: "mx-auto flex h-tabbar w-full max-w-[430px] md:max-w-[720px] items-stretch", children: TABS.map((tab) => {
                const active = isTabActive(location.pathname, tab);
                return (_jsx("li", { className: "relative flex-1", children: _jsxs(NavLink, { to: tab.to, "aria-label": t(tab.ariaKey), "aria-current": active ? 'page' : undefined, className: `
                  relative flex h-full items-center justify-center
                  font-display text-[14px] font-medium tracking-[-0.02em]
                  transition active:scale-[0.97]
                  ${active ? 'text-cyan-core' : 'text-cyan-text-secondary'}
                `, children: [t(tab.labelKey), active ? (_jsx("span", { "aria-hidden": true, className: "\n                      absolute bottom-0 left-1/2 h-[2px] w-12 -translate-x-1/2\n                      bg-cyan-network\n                    " })) : null] }) }, tab.to));
            }) }) }));
}
//# sourceMappingURL=TabBar.js.map